<template>
  <div class="root row p-1 mb-2 vcenter cart-item">
    <!-- <p>{{ cartItem }}</p> -->
    <div class="md-8 sm-12" :set="(product = cartItem.product)">
      <div class="row">
        <!-- <p>{{ getProductImage(product) }}</p> -->
        <div class="sm-4 img pointer" @click.stop="gotoProduct(product.id)">
          <img :src="getProductImage(product)" :alt="product.name" />
        </div>
        <div class="sm-8 p-2 info-container">
          <div>
            <span class="title">{{ product.name }}</span>
            <span class="description">{{ productDescription }}</span>
          </div>
          <div>
            <span>$ {{ product.price }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="md-4 sm-12">
      <!-- {{ productToUpdate === product }} -->
      <!-- <QuantitySelect
        class="mb-2 actions"
        :quantity="cartItem.quantity"
        :loading="addItemLoadingStatus === 1 && productToUpdate === product"
        @update="updateQuantity"
      /> -->
      <quantity-select class="mb-2 actions" :cartItem="cartItem" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import { getProductPrimaryImage } from "@/utils";
import QuantitySelect from "./QuantitySelect";

export default {
  name: "CartItem",
  components: {
    QuantitySelect,
  },
  props: {
    cartItem: {
      type: Object,
      default: () => {},
      required: true,
    },
  },
  computed: {
    ...mapGetters({
      addItemLoadingStatus: "Cart/addCartItemStatus",
    }),

    cartItemTotal() {
      return (
        this.cartItem.quantity *
        (this.cartItem.product.price - this.cartItem.product.discountPrice)
      );
    },
    productDescription() {
      const clamp = 60;
      let description = this.cartItem.product.description;
      if (description.length >= clamp) {
        description = description.substr(0, clamp);
        description += "...";
      }

      return description;
    },
  },
  data() {
    return {
      productToUpdate: "",
    };
  },
  methods: {
    gotoProduct(id) {
      this.$router.push({
        name: "ProductDetails",
        params: { id },
      });
    },

    getProductImage(product) {
      return getProductPrimaryImage(product);
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  justify-content: space-between;
  background-color: white !important;

  .info-container {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .img {
    height: 100px;
    border-radius: 5px;

    img {
      border-radius: inherit;
    }
  }

  .title {
    display: block;
    font-size: 1.3rem;
  }

  .description {
    opacity: 0.7;
  }

  .actions {
    @media only screen and (max-width: $breakpoint-mobile) {
      margin-top: 10px;
    }
  }
}
</style>

<style lang="scss">
.theme-dark .cart-item {
  background-color: $dark-light-color !important;
}
</style>
